import styled from "styled-components";

export const EventPage = styled.div`
  background-color: #fef9fa;
  // min-height: 2000px;
`;
